import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSkeletonElement } from '../CustomSkeletonElement';

interface UserSubtitleProps {
  address: string;
  userId: number;
}

export const UserSubtitle: FC<UserSubtitleProps> = ({ address, userId }) => {
  const { t } = useTranslation();

  if (!address) {
    return (
      <CustomSkeletonElement
        skeletonContainerClassName="user-info-skeleton"
        skeletonChildrenClassName="user-info-skeleton__btn skeleton"
        childrenCount={1}
      />
    );
  }

  return (
    <span>
      {address} <span>| {t('multiAccount.account')}</span> {userId}
    </span>
  );
};
